import { useState } from 'react';
import type { FaqItem } from '@/types/content';

interface AccordionProps {
  items: FaqItem[];
  defaultOpenId?: string;
}

export default function Accordion({ items, defaultOpenId }: AccordionProps) {
  const [openId, setOpenId] = useState<string | null>(defaultOpenId ?? null);

  const toggle = (id: string) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  return (
    <div className="flex flex-col gap-3">
      {items.map((item) => {
        const isOpen = openId === item.id;
        return (
          <div
            key={item.id}
            className={`overflow-hidden rounded-lg border transition-colors ${
              isOpen ? 'border-primary-300 bg-background-50' : 'border-background-200 bg-background-50'
            }`}
          >
            <h3>
              <button
                type="button"
                onClick={() => toggle(item.id)}
                aria-expanded={isOpen}
                aria-controls={`panel-${item.id}`}
                className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
              >
                <span className="font-heading text-base font-bold text-foreground-950">{item.question}</span>
                <span
                  className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-sm transition-colors ${
                    isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-700'
                  }`}
                >
                  <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'} aria-hidden="true" />
                </span>
              </button>
            </h3>
            <div
              id={`panel-${item.id}`}
              role="region"
              className={`px-5 pb-4 text-sm leading-relaxed text-foreground-700 ${isOpen ? 'block' : 'hidden'}`}
            >
              {item.answer}
            </div>
          </div>
        );
      })}
    </div>
  );
}